import { Modal } from 'bootstrap'

document.addEventListener('turbo:load', () => {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-toggle="lightbox"], [data-toggle="custom-lightbox"]')
    if (!link) return

    const modal = document.querySelector('.modal.lightbox')
    if (modal) {
      modal.dataset.lightboxType = link.dataset.lightboxType || ''
    }
  })

  document.addEventListener('click', (e) => {
    const closeButton = e.target.closest('.modal.lightbox .btn-close, .modal.lightbox .btn-close span')
    if (!closeButton) return

    e.preventDefault()
    const modal = closeButton.closest('.modal.lightbox')
    if (modal) Modal.getOrCreateInstance(modal).hide()
  })

  document.addEventListener('click', (e) => {
    const modal = document.querySelector('.modal.lightbox.show')
    if (!modal) return

    const img = modal.querySelector('.modal-dialog .ratio > img')
    if (img && !img.contains(e.target)) {
      Modal.getInstance(modal)?.hide()
    }
  })

  document.addEventListener('shown.bs.modal', (e) => {
    const modal = e.target
    if (!modal.classList.contains('lightbox')) return

    modal.classList.remove('map-lightbox')
    modal.classList.remove('menu-lightbox')

    if (modal.dataset.lightboxType === 'map') {
      modal.classList.add('map-lightbox')
    } else if (modal.dataset.lightboxType === 'menu') {
      modal.classList.add('menu-lightbox')
      const ratio = modal.querySelector('.modal-dialog .ratio')
      if (!ratio) return

      let button = ratio.querySelector('.btn-close')
      if (!button) {
        button = document.createElement('button')
        button.type = 'button'
        button.setAttribute('data-bs-dismiss', 'modal')
        button.setAttribute('aria-label', 'Close')
        ratio.appendChild(button)
        const span = document.createElement('span')
        button.appendChild(span)
      }

      button.className = 'btn-close'
      button.style.zIndex = '2'
    }
  })
})
